import { createAction, props } from '@ngrx/store';
import { Action } from '@ngrx/store';

export const loadOrganization = createAction('[Employee] LoadOrganization', props<any>());
export const loadOrganizationSuccess = createAction('[Employee] LoadOrganization Success', props<{ payload: any }>());
export const loadOrganizationFail = createAction('[Employee] LoadOrganization Fail', props<any>());
export const changeAccount = createAction('[Employee] Change Account', props<{ payload: any }>());

/**
 * Change Account
 */
 export const CHANGE_ACCOUNT = '[Dashboard] Change Account';
 export class ChangeAccount implements Action {
     readonly type = CHANGE_ACCOUNT;
     constructor(public payload: any) {}
 }